import React from 'react';

const Switch = ({ id = '', label = '', value = false, onChange }) => {
  const handleChange = () => {
    const newValue = !value;
    onChange(newValue);
  };

  return (
    <div className="custom-control custom-switch">
      <input type="checkbox" checked={value} onChange={handleChange} className="custom-control-input" id={id} />
      <label className="custom-control-label font-size-md font-weight-regular" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Switch;
